import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {LANG_OPTIONS_WITH_OUT_TRANSLATION} from "../../lang.constants";
import {IsDirty} from "../../services/can-deactivate-guard/is-dirty.interface";
import {WarningModalService} from "../../services/warning-modal/warning-modal.service";
import {Observable, of} from "rxjs";

@Component({
  selector: 'app-system-lang-edit-modal',
  templateUrl: './system-lang-edit-modal.component.pug',
  styleUrls: ['./system-lang-edit-modal.component.scss'],
  standalone: false
})
export class SystemLangEditModalComponent implements OnInit, IsDirty {

  @Input() preferred_language!: string;
  systemLang = LANG_OPTIONS_WITH_OUT_TRANSLATION;
  messages = [];
  public event: EventEmitter<any> = new EventEmitter();
  @ViewChild('langForm', {static: false}) langForm: any;

  constructor(public _bsModalRef: BsModalRef,
              private modal: WarningModalService) {
  }

  ngOnInit(): void {
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.event.emit({'newLang': this.preferred_language});
  }

  isDirty(): boolean {
    return this.langForm.dirty;
  }

  markAsPristine() {
    this.langForm.form.markAsPristine();
  }

  canDeactivate(): Observable<boolean> {
    // If component is dirty, warn user
    if (this.isDirty()) {
      let title = $localize`Leave this page?`;
      let message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
      let cancelButton = $localize`Stay on page`;
      let agreeButton = $localize`Leave this page`;
      return this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton, true);
    } else {
      return of(true);
    }
  }

  setMessages(newMessages) {
    this.messages = this.messages.concat(newMessages);
  }
}
